module.exports = __webpack_public_path__ + "static/media/salsas.ae4b4fcf.svg";